<div class="row">
  <div class="col-md-8 col-sm-12">
    <app-card [hideHeader]="true">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-12">
            <div class="d-flex align-items-center justify-content-between">
              <h5 class="mb-0">{{'global.days' | translate}}: {{ days }}</h5>
              <div class="d-flex gap-2">
                <button
                  class="btn btn-primary"
                  type="button"
                  *ngIf="isEditMode && !isEditing"
                  (click)="enableEditing()"
                  [disabled]="isExchangeLocked"
                >
                  {{'global.edit' | translate}}
                </button>
                <button class="btn btn-outline-secondary" type="button" (click)="cancel()" [disabled]="!isEditMode || isExchangeLocked">
                  {{'global.cancel' | translate}}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <div class="bg-light p-3 rounded">
              <label class="form-label mb-1" for="exchange_order_number">{{ 'doctrine.order.number' | translate }}</label>
              <input id="exchange_order_number" class="form-control" type="text" [value]="orderNo || '-'" disabled />
            </div>
          </div>
        </div>
        <form [formGroup]="form" novalidate>
          <ng-container formArrayName="items">
            <ng-container *ngFor="let itemCtrl of itemsArray.controls; let i = index" [formGroupName]="i">
              <app-card [title]="itemCtrl.controls.label.value"   *ngIf="itemHasVisibleExchangeOptions(itemCtrl)">
                <div class="container">
                  <ng-container formArrayName="orderItemOptions">
                    <ng-container *ngFor="let optCtrl of itemCtrl.controls.orderItemOptions.controls; let j = index; trackBy: trackByControl">
                      <div
                        class="mb-4 mt-2 bg-light text-dark option-box"
                        [formGroupName]="j"
                        *ngIf="optCtrl.controls.isExchangeable.value && hasExchangeTargetChoices(optCtrl)"
                      >
                        <div class="px-3 pt-3 fw-semibold">
                          {{ optCtrl.controls.productName.value || '-' }}
                        </div>
                        <div class="card-body">
                          <div class="row align-items-end">
                            <div class="col-md-6 col-sm-12 mb-2">
                              <label class="form-label mb-1" [attr.for]="'exchange_current_option_' + i + '_' + j">{{'global.current_option' | translate}} *</label>
                              <ng-select
                                [labelForId]="'exchange_current_option_' + i + '_' + j"
                                [items]="[{ id: optCtrl.controls.currentOptionId.value, name: optCtrl.controls.currentOptionName.value }]"
                                bindLabel="name"
                                bindValue="id"
                                [clearable]="false"
                                [searchable]="false"
                                [disabled]="true"
                                [ngModelOptions]="{ standalone: true }"
                                [ngModel]="optCtrl.controls.currentOptionId.value"
                              >
                              </ng-select>
                            </div>

                            <div class="col-md-6 col-sm-12 mb-2">
                              <label class="form-label mb-1 d-flex" [attr.for]="'exchange_new_option_' + i + '_' + j">
                                {{'global.new_option' | translate}} *
                                <span class="tooltip-item ms-1" *ngIf="optCtrl.controls.isLocked.value">
                                  <span class="tooltipBox">
                                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                                  </span>
                                  <span class="desc-place">
                                    <ng-container>
                                      <div>
                                        {{'exchange.erros.tooltip' | translate}}
                                      </div>
                                    </ng-container>
                                  </span>
                                </span>
                              </label>
                              <ng-select
                                [labelForId]="'exchange_new_option_' + i + '_' + j"
                                [items]="targetsForOption(optCtrl)"
                                bindLabel="name"
                                bindValue="id"
                                [clearable]="false"
                                formControlName="selectedTargetId"
                                [disabled]="!optCtrl.controls.canSelect.value"
                              >
                              </ng-select>
                            </div>

                            <div class="col-md-2 col-sm-12 mb-2"></div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>

                  <div class="row mt-2" *ngIf="hasMultipleVisibleExchangeOptions(itemCtrl)">
                    <div class="col-12">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="allowSeparateSelection"
                          [attr.id]="'exchange_box_separate_' + i"
                        />
                        <label class="form-check-label" [attr.for]="'exchange_box_separate_' + i">
                        {{'global.allow_separate_selection' | translate}}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </app-card>
            </ng-container>
          </ng-container>

          <app-card title="Customer information">
            <div class="container" formGroupName="customer">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label" for="exchange_customer_first_name">{{'doctrine.user.name'|translate}} *</label>
                  <input id="exchange_customer_first_name" class="form-control" type="text" formControlName="firstName" />
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label" for="exchange_customer_last_name">{{'doctrine.user.lastName'|translate}} *</label>
                  <input id="exchange_customer_last_name" class="form-control" type="text" formControlName="lastName" />
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label" for="exchange_customer_street">{{'doctrine.user.street'|translate}} *</label>
                  <input id="exchange_customer_street" class="form-control" type="text" formControlName="street" />
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label" for="exchange_customer_house_number">{{'doctrine.user.house_number'|translate}} *</label>
                  <input id="exchange_customer_house_number" class="form-control" type="text" formControlName="houseNumber" />
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label" for="exchange_customer_postal_code">{{'doctrine.user.zipCode'|translate}} *</label>
                  <input id="exchange_customer_postal_code" class="form-control" type="text" formControlName="postalCode" />
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label" for="exchange_customer_land">{{'doctrine.user.land'|translate}} *</label>
                  <input id="exchange_customer_land" class="form-control" type="text" formControlName="land" />
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label" for="exchange_customer_city">{{'doctrine.user.city'|translate}} *</label>
                  <input id="exchange_customer_city" class="form-control" type="text" formControlName="city" />
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label" for="exchange_customer_email">{{'doctrine.user.email'|translate}} *</label>
                  <input
                    id="exchange_customer_email"
                    class="form-control"
                    type="email"
                    formControlName="email"
                    [placeholder]="'exchange.email_placeholder' | translate"
                    [class.is-invalid]="emailControl.invalid && emailControl.touched"
                  />
                  <div
                    class="messages text-danger"
                    *ngIf="emailControl.invalid && emailControl.touched && emailErrorKey"
                  >
                    {{ emailErrorKey | translate }}
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label" for="exchange_customer_phone">{{'doctrine.user.phone'|translate}} *</label>
                  <input id="exchange_customer_phone" class="form-control" type="text" formControlName="telephoneNumber" />
                </div>
              </div>

              <div class="row">
                <div class="col-12 mb-2">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControlName="consentA"
                      [attr.id]="'exchange_customer_consent_a'"
                    />
                    <label class="form-check-label" [attr.for]="'exchange_customer_consent_a'">{{'exchange.terms.first' | translate}} *</label>
                  </div>
                </div>
                <div class="col-12 mb-2">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControlName="consentB"
                      [attr.id]="'exchange_customer_consent_b'"
                    />
                    <label class="form-check-label" [attr.for]="'exchange_customer_consent_b'">{{'exchange.terms.second' | translate}} *</label>
                  </div>
                </div>
              </div>
            </div>
          </app-card>

          <div class="row justify-content-end" *ngIf="isEditing">
            <div class="col-sm-2">
              <button class="btn btn-primary btn-block" type="button" (click)="submit()" [disabled]="form.invalid || !canSubmit || isExchangeLocked || !hasSelectedExchange">
                {{ (isEditMode ? 'global.save' : 'global.add') | translate }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </app-card>
  </div>

  <div class="col-sm-12 col-md-4">
    <app-card title="Exchange information" *ngIf="isEditMode">
      <div>
        <div class="row pb-2">
          <div class="col-6 font-weight-bold">{{ 'exchange.created' | translate }}</div>
          <div class="col-6">
            {{ exchangeInfo.createdAt ? (exchangeInfo.createdAt | date : 'medium') : '-' }}
          </div>
        </div>
        <div class="row pb-2">
          <div class="col-6 font-weight-bold">{{ 'exchange.service_number' | translate }}</div>
          <div class="col-6">{{ exchangeInfo.serviceNumber || '-' }}</div>
        </div>
        <div class="row pb-2">
          <div class="col-6 font-weight-bold">{{ 'exchange.physical_delivery_date' | translate }}</div>
          <div class="col-6">
            {{ exchangeInfo.physicalDeliveryAt ? (exchangeInfo.physicalDeliveryAt | date : 'medium') : '-' }}
          </div>
        </div>
      </div>
    </app-card>

    <app-card [title]="'exchange.notes' | translate">
      <div class="container-fluid">
        <div class="mb-3">
          <label class="form-label mb-1" for="exchange_status">{{ 'exchange.status' | translate }}</label>
          <ng-select
            labelForId="exchange_status"
            [items]="statusOptions"
            bindLabel="translationKey"
            bindValue="id"
            [clearable]="false"
            [searchable]="false"
            [formControl]="form.controls.status"
          >
            <ng-template ng-label-tmp let-item="item">{{ item.translationKey | translate }}</ng-template>
            <ng-template ng-option-tmp let-item="item">{{ item.translationKey | translate }}</ng-template>
          </ng-select>
        </div>

        <div class="mb-3">
          <label class="form-label mb-1" for="exchange_dealer_note">{{ 'exchange.dealerNote' | translate }}</label>
          <textarea
            id="exchange_dealer_note"
            class="form-control"
            rows="3"
            [formControl]="form.controls.dealerNote"
          ></textarea>
        </div>

        <div class="mb-3" *ngIf="canEditLogisticNote">
          <label class="form-label mb-1" for="exchange_logistic_note">{{ 'exchange.logisticNote' | translate }}</label>
          <textarea
            id="exchange_logistic_note"
            class="form-control"
            rows="3"
            [formControl]="form.controls.logisticNote"
          ></textarea>
        </div>

        <div class="d-flex justify-content-end" *ngIf="isEditing">
          <button
            class="btn btn-primary"
            type="button"
            (click)="submit()"
            [disabled]="form.invalid || !canSubmit || isExchangeLocked || !hasSelectedExchange"
          >
            {{ (isEditMode ? 'global.save' : 'global.add') | translate }}
          </button>
        </div>
      </div>
    </app-card>
  </div>
</div>

